import React from "react";
import { IconButton } from "subframe/components/IconButton";
import { Button } from "subframe/components/Button";

interface SuccessViewProps {
  hidden?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onCancel?: () => void;
  onReturnToTaskCenter?: () => void;
}

const SuccessView: React.FC<SuccessViewProps> = ({
  hidden = false,
  open = false,
  onOpenChange = () => {},
  onCancel = () => {},
  onReturnToTaskCenter = () => {},
}) => {
  const handleClose = () => {
    onOpenChange(false);
  };

  // Custom mobile-friendly drawer
  if (!open || hidden) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-end">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={handleClose}
      />

      {/* Drawer Content */}
      <div className="relative flex h-full w-full flex-col bg-white sm:h-full sm:w-112 lg:w-128">
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-start relative">
          {/* Header */}
          <div className="flex w-full items-center justify-between border-b border-solid border-neutral-border px-3 sm:px-4 py-3 sm:py-2">
            <IconButton
              size="medium"
              icon="FeatherChevronLeft"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {}}
            />
            <div className="flex grow shrink-0 basis-0 flex-col items-start justify-center gap-2 self-stretch pl-2 sm:pl-4">
              <span className="hidden w-full text-subheader font-subheader text-default-font">
                Jason Yu
              </span>
            </div>
            <div className="flex items-center justify-end gap-1">
              <IconButton
                size="medium"
                icon="FeatherPin"
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {}}
              />
              <IconButton size="medium" icon="FeatherX" onClick={handleClose} />
            </div>
          </div>

          {/* Main Content */}
          <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-4 px-2 py-2 overflow-auto">
            <div className="flex w-full flex-col items-start gap-4 sm:gap-6 px-3 sm:px-4 py-4">
              <div className="flex w-full items-center justify-between">
                <span className="text-lg sm:text-xl md:text-header font-header text-default-font">
                  Log Follow-up
                </span>
              </div>
              <div className="flex w-full flex-col items-center gap-4 sm:gap-6 px-4 sm:px-6 py-4 sm:py-6">
                <div className="flex w-full flex-col items-center justify-center gap-4 sm:gap-6">
                  <img
                    className="flex-none"
                    src="https://res.cloudinary.com/subframe/image/upload/v1746652964/uploads/28/gdv8gtpcqiqg1yakqh3e.png"
                    alt="Success"
                  />
                </div>
                <div className="flex w-full flex-col items-center gap-2 text-center">
                  <span className="text-lg sm:text-xl md:text-header font-header text-default-font">
                    Log added successfully
                  </span>
                  <span className="text-sm sm:text-body font-body text-subtext-color px-2">
                    Your follow-up has been recorded
                  </span>
                </div>
                <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 w-full sm:w-auto">
                  <Button
                    variant="neutral-secondary"
                    className="w-full sm:w-auto"
                    onClick={onCancel}
                  >
                    Log Another Follow-up
                  </Button>
                  <Button
                    icon="FeatherArrowLeft"
                    className="w-full sm:w-auto"
                    onClick={onReturnToTaskCenter}
                  >
                    Return to Task Center
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessView;
